import styles from "./SectionGridGallery.module.css";
import img1 from "../../../assets/images/galeria/imagen 1.png";
import img2 from "../../../assets/images/galeria/imagen 2.png";
import img3 from "../../../assets/images/galeria/imagen 3.png";
import img4 from "../../../assets/images/galeria/imagen 4.png";
import img5 from "../../../assets/images/galeria/imagen 5.png";
import img6 from "../../../assets/images/galeria/imagen 6.png";
import img7 from "../../../assets/images/galeria/imagen 7.png";
import img8 from "../../../assets/images/galeria/imagen 8.png";
import img9 from "../../../assets/images/galeria/imagen 9.png";
import img10 from "../../../assets/images/galeria/imagen 10.jpeg";
import img11 from "../../../assets/images/galeria/imagen 11.jpeg";
import img12 from "../../../assets/images/galeria/imagen 12.jpeg";

const SectionGridGalery = () => {
  const galleryData = {
    "Expo Transporte  Guadalajara 2024": [img1, img2, img3],
    "Expo Manufactura 2025": [img4, img5, img6],
    "Expo Proveedores del Transporte Puebla 2025": [img7, img8, img9],
    "Expo Proveedores del Transporte Monterrey 2025": [img10, img11, img12],
  };

  return (
    <section className={styles.section}>
      <div className={styles.headerBar}>
        <div className={styles.headerText}>Galería</div>
      </div>
      {/* <div className={styles.content}>
        <div className={styles.title}>Expo Guadalajara 2024</div>
        <div className={styles.gallery}>
          <img src="https://placehold.co/415x311" alt="Foto 1" />
          <img src="https://placehold.co/415x311" alt="Foto 2" />
          <img src="https://placehold.co/415x311" alt="Foto 3" />
        </div>
      </div> */}

      {Object.entries(galleryData).map(([title, images]) => (
        <div className={styles.content} key={title}>
          <div className={styles.title}>{title}</div>
          <div className={styles.gallery}>
            {images.map((src, idx) => (
              <img
                key={idx}
                src={src}
                alt={`${title} - Imagen ${idx + 1}`}
                loading="lazy"
              />
            ))}
          </div>
        </div>
      ))}
    </section>
  );
};

export default SectionGridGalery;
